import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 0 1em;
  position: relative;

  /* Ensures the livechat button does not blocks the UI content. */
  padding-bottom: 50px;
`;
